import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICCComponent } from './icc.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '../../../@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    declarations: [
        ICCComponent
    ],
    imports: [
        CommonModule,
        MatInputModule,
        MatIconModule,
        FuseSharedModule,
        TranslateModule,
        MatButtonModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatChipsModule,
        MatAutocompleteModule
    ],
    exports: [
        ICCComponent
    ]
})
export class ICCModule { }
